/* Shopify supplies monetary amounts; displays never supply pricing data. */
(function (root) {
  'use strict';
  if (root.BareProductPricing) return;

  function offer(variant, sellingPlanId = null) {
    const allocation = sellingPlanId == null ? null : variant?.selling_plan_allocations?.find(
      (item) => String(item.selling_plan_id) === String(sellingPlanId)
    );
    const valid = !!variant && (sellingPlanId == null ? !variant.requires_selling_plan : !!allocation);
    const price = allocation?.price ?? variant?.price ?? 0;
    const compareAtPrice = allocation?.compare_at_price ?? variant?.compare_at_price ?? 0;
    const savings = Math.max(0, compareAtPrice - price);
    return Object.freeze({
      valid, price, compareAtPrice, savings,
      savingsPercent: compareAtPrice > 0 ? Math.round(savings * 100 / compareAtPrice) : 0,
      perDeliveryPrice: allocation?.per_delivery_price ?? price,
      unitPrice: allocation?.unit_price ?? variant?.unit_price ?? null,
      sellingPlanId: allocation?.selling_plan_id ?? null,
      allocation: allocation ?? null,
    });
  }

  const forms = new WeakMap();
  function forForm(form) {
    if (!forms.has(form)) {
      let state = null;
      forms.set(form, {
        get state() { return state; },
        offer(sellingPlanId = null) { return offer(state?.variant, sellingPlanId); },
        update(variant, sellingPlanId = null, quantity = 1) {
          state = Object.freeze({
            variant, variantId: variant?.id ?? null, quantity,
            oneTime: offer(variant), selected: offer(variant, sellingPlanId),
          });
          return state;
        },
      });
    }
    return forms.get(form);
  }
  root.BareProductPricing = Object.freeze({ offer, forForm });
})(typeof window === 'undefined' ? globalThis : window);
